import { render, staticRenderFns } from "./sgjTable.vue?vue&type=template&id=20fecfbe&scoped=true"
import script from "./sgjTable.vue?vue&type=script&lang=ts"
export * from "./sgjTable.vue?vue&type=script&lang=ts"
import style0 from "./sgjTable.vue?vue&type=style&index=0&id=20fecfbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fecfbe",
  null
  
)

export default component.exports